var React = require('react');

function ExclamationYellow (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"10","cy":"10","r":"10","fill":"#EBA920","key":0}),React.createElement("path",{"d":"M11.128 8.01V5H9.308V8.01L9.588 11.58H10.848L11.128 8.01ZM9 13.722C9 14.408 9.532 14.94 10.218 14.94C10.904 14.94 11.45 14.408 11.45 13.722C11.45 13.036 10.904 12.49 10.218 12.49C9.532 12.49 9 13.036 9 13.722Z","fill":"#FFFBE7","key":1})]);
}

ExclamationYellow.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = ExclamationYellow;

ExclamationYellow.default = ExclamationYellow;
